import React from "react";

import { Button } from "@material-ui/core";
import { OpenInNew } from "@material-ui/icons";

export default function ExternalLink({ url, ...props }) {
  const icon = <OpenInNew fontSize="inherit" />;

  return (
    <Button
      component="a"
      href={url}
      endIcon={icon}
      rel="noopener noreferrer"
      target="_blank"
      {...props}
    />
  );
}
